import React from 'react';

import type {IconProp} from '@fortawesome/fontawesome-svg-core';
import {faPlus, faSpinner} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {LiabilitiesInlineTable} from '../components';
import type {ILiabilitiesSubStepProps} from '../financials.types';

const iconPlus = faPlus as IconProp;
const iconSpinner = faSpinner as IconProp;

export const LiabilitiesSubStep: React.FC<ILiabilitiesSubStepProps> = ({
  liabilityStatus,
  isLoadingLiabilities,
  liabilityRows,
  liabilityAccountTypes,
  isSavingLiabilities,
  onAddLiability,
  onUpdateLiabilityRowField,
  onDeleteLiability,
}) => (
  <div className="financials-liabilities">
    <div className="sr-only" role="status" aria-live="polite">
      {liabilityStatus}
    </div>

    <div className="financials-liabilities__actions">
      <button
        type="button"
        className="btn btn-tertiary"
        onClick={onAddLiability}
        disabled={isSavingLiabilities}
      >
        <FontAwesomeIcon icon={iconPlus} aria-hidden="true" />
        <span>Add liability</span>
      </button>
    </div>

    {isLoadingLiabilities ? (
      <div className="financials-liabilities__loading" role="status">
        <FontAwesomeIcon icon={iconSpinner} spin />
        <span>Loading liabilities…</span>
      </div>
    ) : null}

    {!isLoadingLiabilities && liabilityRows.length === 0 ? (
      <div className="application-card">
        <div className="application-empty-state">
          <h3>Confirm your liabilities for 2025</h3>
          <p>
            Declare loans, credit facilities and outstanding balances so we have
            a full picture of your obligations.
          </p>
        </div>
      </div>
    ) : null}

    {!isLoadingLiabilities && liabilityRows.length > 0 ? (
      <LiabilitiesInlineTable
        liabilityRows={liabilityRows}
        liabilityAccountTypes={liabilityAccountTypes}
        isSavingLiabilities={isSavingLiabilities}
        onUpdateLiabilityRowField={onUpdateLiabilityRowField}
        onDeleteLiability={onDeleteLiability}
      />
    ) : null}
  </div>
);
